import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { selectAccessToken } from 'src/app/store/selectors/token.selectors';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  accessToken$ = this.store.select(selectAccessToken)
  accessToken: string | null = null

  constructor(
    // private router: Router,
    // private ngZone: NgZone,
    private cookieService:CookieService,
    private store: Store
  ) { 
    this.accessToken$.subscribe((data) => {
      this.accessToken = data
    })
  }

  get isLoggedIn():boolean{
    let accessToken = this.cookieService.get('accessToken')
    if(!accessToken) {
      accessToken = this.accessToken || ''
    }
    return accessToken ? true : false
  }

  get isMemberLoggedIn(): boolean {
    const memberAccessToken = sessionStorage.getItem('memberAccessToken')
    return memberAccessToken !== null
  }
}
